var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExodus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 42,
    viewBox: "0 0 207 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_120)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2068 11.7272L24.1248 0V6.55725L35.7248 14.0122L34.3594 18.2831H24.1248V23.7169H34.3594L35.7248 27.9877L24.1248 35.4427V42L42.2068 30.3109L39.2504 21.0184L42.2068 11.7259V11.7272Z",
    fill: "url(#paint0_linear_2_120)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39282 23.7169H18.5902V18.2831H8.35434L7.02741 14.0122L18.5902 6.55725V0L0.50824 11.7272L3.46462 21.0197L0.50824 30.3109L18.6287 42V35.4441L7.02874 27.9877L8.39282 23.7169Z",
    fill: "url(#paint1_linear_2_120)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2068 11.7272L24.1248 0V6.55725L35.7248 14.0122L34.3594 18.2831H24.1248V23.7169H34.3594L35.7248 27.9877L24.1248 35.4427V42L42.2068 30.3109L39.2504 21.0184L42.2068 11.7259V11.7272Z",
    fill: "url(#paint2_linear_2_120)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39282 23.7169H18.5902V18.2831H8.35434L7.02741 14.0122L18.5902 6.55725V0L0.50824 11.7272L3.46462 21.0197L0.50824 30.3109L18.6287 42V35.4441L7.02874 27.9877L8.39282 23.7169Z",
    fill: "url(#paint3_linear_2_120)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9308 0H0.530823V42H41.9308V0Z",
    fill: "url(#paint4_linear_2_120)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1823 11.55V15.2211H61.077V18.9787H75.6134V22.6511H61.0756V26.7776H78.1837V30.45H56.6875V11.55H78.1837H78.1823ZM80.6106 30.45L90.4391 20.8858L80.8892 11.55H86.9307L93.6688 18.2962L100.13 11.55H105.782L96.259 20.8858L106.088 30.45H99.9903L93.6688 23.5043L86.4583 30.45H80.6106Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.873 11.55C125.836 11.55 130.625 15.4941 130.625 21C130.625 26.5059 125.836 30.45 117.873 30.45C109.91 30.45 105.148 26.5059 105.148 21C105.148 15.4941 109.91 11.55 117.873 11.55ZM117.873 15.0832C113.083 15.0832 109.553 17.4667 109.553 21C109.553 24.5332 113.083 26.9167 117.873 26.9167C122.69 26.9167 126.22 24.5332 126.22 21C126.22 17.4667 122.69 15.0832 117.873 15.0832ZM146.498 11.55C152.876 11.55 156.719 15.0504 156.719 20.9711C156.719 26.9482 152.904 30.45 146.553 30.45H133.63V11.55H146.498ZM152.207 20.9711C152.207 17.2699 149.979 15.2224 145.94 15.2224H138.003V26.7776H145.94C149.979 26.7776 152.207 24.6999 152.207 20.9711ZM171.18 30.45C164.464 30.45 159.37 27.4352 159.37 21.8794V11.55H163.765V21.4594C163.765 24.8942 167.374 26.4862 171.18 26.4862C175.015 26.4862 178.624 24.9217 178.624 21.4594V11.55H182.989V21.8794C182.989 27.4352 177.924 30.45 171.18 30.45ZM195.289 30.45C191.681 30.45 187.79 29.7924 185.027 28.56L186.466 25.053C188.946 26.1765 192.357 26.8892 195.429 26.8892C198.954 26.8892 202.251 26.1489 202.251 24.8351C202.251 23.877 201.208 23.4649 199.037 23.1367L192.892 22.4792C188.156 21.8492 185.845 20.2335 185.845 17.3841C185.845 13.7143 189.763 11.55 195.514 11.55C198.981 11.55 203.745 12.18 206.197 13.2759L204.76 16.6176C202.336 15.6306 198.22 15.1384 195.316 15.1384C192.328 15.1384 190.355 15.8222 190.355 17.0822C190.355 17.9589 191.342 18.3973 193.879 18.7543L199.855 19.4106C204.422 20.0406 206.789 21.5762 206.789 24.5608C206.789 28.3408 201.772 30.45 195.289 30.45Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_120",
    x1: 36.3577,
    y1: 44.8875,
    x2: 24.4933,
    y2: -4.67142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_120",
    x1: 36.3577,
    y1: 44.8875,
    x2: 24.4932,
    y2: -4.67142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_120",
    x1: 36.3577,
    y1: 44.8875,
    x2: 24.4933,
    y2: -4.67142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_120",
    x1: 36.3577,
    y1: 44.8875,
    x2: 24.4932,
    y2: -4.67142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_120",
    x1: 3.18467,
    y1: 9.45,
    x2: 23.9855,
    y2: 25.1555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8952FF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DABDFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 207,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExodus);
export default __webpack_public_path__ + "static/media/exodus.b5474a4eaa20aa9838f3407fe38a31c5.svg";
export { ForwardRef as ReactComponent };